import {
    Component,
    OnInit,
    Renderer2,
    ViewChild,
    ElementRef,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { TitleService } from "@app/services/title.service";

@Component({
    selector: "app-contact-page",
    templateUrl: "./contact-page.component.html",
    styleUrls: ["./contact-page.component.scss"],
})
export class ContactPageComponent implements OnInit {
    at = null;
    isSuccessShown: boolean = false;
    isFailureShown: boolean = false;
    @ViewChild("feedbackType") input: ElementRef<HTMLInputElement>;
    constructor(
        private renderer: Renderer2,
        private http: HttpClient,
        private titleService: TitleService,
    ) {}

    ngOnInit(): void {
        this.titleService.setTitle("CoP");
        // this.renderer.setStyle(this.input.nativeElement, 'display', 'none');
        // this.renderer.setStyle(this.input.nativeElement.parentNode.firstChild, 'display', 'show');
    }

    pageTitleArea: pageTitle[] = [
        {
            title: "CoP - Feedback",
        },
    ];
    contactInfoBox1: InfoBox1[] = [
        {
            icon: "bx bx-map",
            title: "Our Address",
            location: "175 5th Ave, New York, NY 10010, United States",
        },
    ];
    contactInfoBox2: InfoBox2[] = [
        {
            icon: "bx bx-phone-call",
            title: "Contact",
            number: "(+44) - 45789 - 5789",
            email: "hello@wilo.com",
        },
    ];
    contactInfoBox3: InfoBox3[] = [
        {
            icon: "bx bx-time-five",
            title: "Hours of Operation",
            text1: "Monday - Friday: 09:00 - 20:00",
            text2: "Sunday & Saturday: 10:30 - 22:00",
        },
    ];

    sectionTitle: sectionTitleContent[] = [
        {
            subTitle: "Get In Touch",
            title: "Ready to Get Started?",
            paragraphText:
                "Your email address will not be published. Required fields are marked *",
        },
    ];
    contactImage: Image[] = [
        {
            img: "assets/img/contact.png",
        },
    ];

    SendFeedback() {
        let feedback = {
            name: (document.getElementById("name") as HTMLInputElement).value,
            email: (document.getElementById("email") as HTMLInputElement).value,
            role: (document.getElementById("role") as HTMLInputElement).value,
            feedbacktype: (
                document.getElementById("feedbackType") as HTMLInputElement
            ).value,
            feedback: (document.getElementById("message") as HTMLInputElement)
                .value,
        };

        console.log(feedback.name);
        this.sendRequest(feedback);
    }

    sendRequest(feedback) {
        let httpOptions = {};
        return this.http.post("", feedback, httpOptions);
    }
}
class pageTitle {
    title: string;
}
class InfoBox1 {
    icon: string;
    title: string;
    location: string;
}
class InfoBox2 {
    icon: string;
    title: string;
    number: string;
    email: string;
}
class InfoBox3 {
    icon: string;
    title: string;
    text1: string;
    text2: string;
}

class sectionTitleContent {
    subTitle: string;
    title: string;
    paragraphText: string;
}
class Image {
    img: string;
}
class Feedback {
    name: string;
    email: string;
    role: string;
    feedbacktype: string;
    feedback: string;
}
